export default "__VITE_ASSET__DcHWt9CF__"